import * as experiences from '@cascade/react/experiences';
import { useUserClient } from '@cascade/react-dom/hooks';
import type { PropsWithChildren } from 'react';
import { useMatch, useParams } from 'react-router-dom';
import { llmSse } from './Experience.clients.ts';
import { EXPERIENCE_PATH, EXPERIENCE_SUMMARY_PATH } from '#config/index.ts';

const EXPERIENCE_SUMMARY_PATTERN = `/${EXPERIENCE_PATH}/${EXPERIENCE_SUMMARY_PATH}`;

export const ExperienceProvider = ({ children }: PropsWithChildren) => {
  const { experienceId = '' } = useParams();
  const summaryMatch = useMatch(EXPERIENCE_SUMMARY_PATTERN);
  const { userClient, isMobile, userAgent } = useUserClient();

  return (
    <experiences.ExperienceProvider
      experienceId={experienceId}
      isMobile={isMobile}
      isStepHidden={Boolean(summaryMatch)}
    >
      <experiences.ExperienceChatProvider
        sse={llmSse}
        userClient={userClient}
        userAgent={userAgent}
      >
        {children}
      </experiences.ExperienceChatProvider>
    </experiences.ExperienceProvider>
  );
};
